'use strict';

if (typeof Promise === 'undefined') {
    // Rejection tracking prevents a common issue where React gets into an
    // inconsistent state due to an error, but it gets swallowed by a Promise,
    // and the user has no idea what causes React's erratic future behavior.
    require('promise/lib/rejection-tracking').enable();
    window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
    require('raf').polyfill(global);
}

/* Note: Add polyfills here. */
/* [core-js polyfills] */
import 'core-js/fn/array/includes';
import 'core-js/fn/array/find';
import 'core-js/fn/array/some';
import 'core-js/fn/array/filter';
import 'core-js/fn/array/index-of';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/concat';
import 'core-js/fn/array/every';
import 'core-js/fn/array/for-each';
import 'core-js/fn/array/push';
import 'core-js/fn/array/pop';
import 'core-js/fn/array/splice';
import 'core-js/fn/symbol';
import 'reflect-metadata';


//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 701
// module chunks = 0